export default "__VITE_ASSET__50194079__"